/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Tray_Provider_LocalInputs */



/**
* | output |
* | --- |
* | "local" |
*
* @param {Upload_Tray_Provider_LocalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const upload_tray_provider_local = /** @type {((inputs?: Upload_Tray_Provider_LocalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Tray_Provider_LocalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("lokal")
	return /** @type {LocalizedString} */ ("local")
});